const { translate } = require('./locale')
const { getFromDB } = require('./location')
const { shortenCompanyName } = require('./text')
const fetch = require('node-fetch');

// Могут подписывать и давать право подписи другим
const canSignAuthorize = [
    'CEO',
    'CAN_SIGN'
]

const KGDAbortTimeout = 5000
const pendingKGDChecks = new Map()

function isName(name) {
    if(name && /^[a-zA-Zа-яА-ЯёЁ\u04D8\u04D9\u04B0\u04B1\u0406\u0456\u04A2\u04A3\u0492\u0493\u04AE\u04AF\u049A\u049B\u04E8\u04E9\u04BA\u04BB\s'-]+$/.test(name)) return true
    return false
}

function isPatronymic(name) {
    if(!name || /^[a-zA-Zа-яА-ЯёЁ\s'-]+$/.test(name)) return true
    return false
}

function isEmail(email) {
    if(email && /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(email)) return true
    return false
}

function isPhoneNumber(phone) {
    if(phone && /^\+[7]{1}\s\([7]{1}[0-9]{2}\)\s[0-9]{3}-[0-9]{2}-[0-9]{2}$/.test(phone)) return true
    return false
}

function isClearPhoneNumber(phone) {
    if(phone && /^[7]{2}[0-9]{9}$/.test(phone)) return true
    return false
}

function checkIdNum(id) {
    if(!Number(id)) return false

    id = id.toString()

    if(id.length != 12) return false
    
    if(id.substring(2, 4) > 12 || id[4] > 6) return false

    if(id[4] <= 3 && id[6] > 6) return false

    let sum = 0,
        controlNumber = 0,
        altSum = 0,
        altWeight = [3, 4, 5, 6, 7, 8, 9, 10, 11, 1, 2],
        shortId = id.slice(0, -1) ?? '',
        last = id.slice(-1) ?? ''

    for(let a in shortId) {
        sum += Number(shortId[a]) * (Number(a)+1)
        altSum += Number(shortId[a]) * (Number(altWeight[a]))
    }

    controlNumber = sum % 11 != 10 ? sum % 11 : altSum % 11

    return last == controlNumber
}

function extractFromIdNum(id, param) {
    if(checkIdNum(id)) {
        id = id.toString()

        // type
        if(param === 'type') {
            if(id[4] <= 3) return 'person'
            if(id[4] > 3) return 'entity'
        }

        // birthdate
        if(param === 'birthdate') {
            if(id[4] <= 3) {
                let century = ''

                if(id[6] >= 1 && id[6] < 3) century = '18'
                if(id[6] >= 3 && id[6] < 5) century = '19'
                if(id[6] >= 5 && id[6] < 7) century = '20'
                if(id[6] >= 7) return `No ${param} - incorrect id`

                return `${id.slice(4, 6)}.${id.slice(2, 4)}.${century}${id.slice(0, 2)}`
            } else {
                return 'No birthdate (not iin)'
            }
        }

        // gender
        if(param === 'gender') {
            if(id[4] <= 3) {
                if(id[6] == 0) return 'Gender unknown'
                if(id[6] != 0 && id[6] <= 6 && id[6] % 2 == 1) return 'male'
                if(id[6] != 0 && id[6] <= 6 && id[6] % 2 == 0) return 'female'
                if(id[6] >= 7) return `No ${param} - incorrect id`
            } else {
                return 'No gender (not iin)'
            }
        }

        // registration date
        if(param === 'regDate') {
            if(id[4] > 3) {
                return `${id.slice(2, 4)}.${id.slice(0, 2)}`
            } else {
                return 'No registration date (not bin)'
            }
        }

        // entity type
        if(param === 'entityType') {
            if(id[4] > 3) {
                if(id[4] == 4) return 'Resident entity'
                if(id[4] == 5) return 'Non-resident entity'
                if(id[4] == 6) return 'Individual entrepreneur'
                if(id[4] > 6) return `No ${param} - incorrect id`
            } else {
                return 'No entity type (not bin)'
            }
        }

        // entity feature
        if(param === 'entityFeature') {
            if(id[4] > 3) {
                if(id[5] == 0) return 'Head office'
                if(id[5] == 1) return 'Branch'
                if(id[5] == 2) return 'Representative office'
                if(id[5] == 3) return 'Farming (joint)'
                if(id[5] > 3) return `No ${param} - incorrect id`
            } else {
                return 'No entity feature (not bin)'
            }
        }
    } else {
        return `No ${param} - incorrect id`
    }
}

function getObjectFromPhoneNumber(phone) {
    let obj = {}

    phone = getClearPhoneNumber(phone)
    obj.prefix = '+' + phone.substr(0, 1)
    obj.operator = phone.substr(1, 3)
    obj.number = phone.substr(4, 7)

    if(obj.prefix === '' || obj.operator === '' || obj.number === '' || obj.number.length < 7) return false
    
    return obj
}

function getPhoneNumberFromObject(phone) {
    let { prefix = '', operator = '', number = '' } = phone
    
    if(phone) return prefix + ' (' + operator + ') ' + number.substr(0, 3) + '-' + number.substr(3, 2) + '-' + number.substr(5, 2)
    return
}

// +7 (777) 000-70-07 -> 77770007007
function getClearPhoneNumber(phone, countryCode = '7') {
    if(!phone) return false

    phone = phone.toString()
    
    let cleanPhone = phone.replace(/\D+/g, '')

    if(cleanPhone && cleanPhone.length === 11) return countryCode + cleanPhone.slice(1)

    return cleanPhone
}

// 77770007007 -> +7 (777) 000-70-07
function getFullPhoneNumber(phone) {
    if(!phone) return ''

    return getPhoneNumberFromObject(getObjectFromPhoneNumber(phone))
}

function clearDublicateLocalities(str) {
    const arr = str.split(', ')
    return arr.filter((value, index) => arr.indexOf(value) === index).join(', ')
}

function getUsername(title, shorted = null) {
    let { lastName = '', firstName = '', patronymic = '', company_name = '' } = title
    let _title = title?.title || ''

    lastName = clearQuotes(lastName)
    firstName = clearQuotes(firstName)
    patronymic = clearQuotes(patronymic)
    company_name = clearQuotes(company_name)

    if(company_name) return shortenCompanyName(company_name).toUpperCase()

    if(shorted !== null && shorted === true) {
        firstName = firstName ? firstName.slice(0, 1) + '.' : ''
        patronymic = patronymic ? patronymic.slice(0, 1) + '.' : ''
    }

    let username = [lastName, firstName, patronymic].filter(Boolean).join(' ')

    if(!username) return _title ? _title.toUpperCase() : '-'

    return username.toUpperCase()
}

function getFullName(obj, shorted = false) {
    let { lastName = '', firstName = '', patronymic = '' } = obj

    if(shorted) {
        firstName = firstName ? firstName.slice(0, 1) + '.' : ''
        patronymic = patronymic ? patronymic.slice(0, 1) + '.' : ''
    }

    let fullname = [lastName, firstName, patronymic].filter(Boolean).join(' ')

    return fullname || ''
}

function clearQuotes(str) {
    str = str.replace(/"/g, '')
    str = str.replace(/'/g, '')
    str = str.replace(/«/g, '')
    str = str.replace(/»/g, '')

    return str
}

// Проверяет, может ли пользователь наделять правом подписи
function isCanSignAuthorize(arr = []) {
    let can = false

    for(let i in arr) {
        if(canSignAuthorize.includes(arr[i])) {
            can = true
            break
        }
    }

    return can
}

// Проверяет, имеет ли пользователь право подписи от имени компании
async function checkCanSignFromCompany(companyIdNum = '', userIdNum = '') {
    if(!companyIdNum || !userIdNum) return false

    let t = 'sign_rights'
    
    let q = await db.select(t, {
        filter: { company_id_num: companyIdNum, user_id_num: userIdNum }
    })

    return q.length > 0
}

async function getBics() {
    let t = 'bank_bics'
    let q = await db.select(t)

    return q
}

async function getBankCodes() {
    let t = 'bank_bics'
    let q = await db.execute(`SELECT code FROM ${t};`)

    return q
}

async function checkIban(iban) {
    if(iban.length == 0)
        return iban
    //Check length. Kazakhstan IBAN is always 20 characters long
    if(iban.length != 20)
        return false
    
    //Check if IBAN is KZ
    if (iban.slice(0, 2) != 'KZ') 
        return false

    if (checkCheckDigits(iban) == false)
        return false

    let bankCodes = await getBankCodes()
    let isValidCode = false

    for(let i in bankCodes) {
        if(iban.substring(4, 7) == bankCodes[i].code){
            isValidCode = true
            break
        }
    }

    if(!isValidCode)
        return false

    return iban
}

function checkCheckDigits(iban) {
    iban = iban.substring(4) + iban.substring(0, 4)

    let transformedIban = ''

    for (let i = 0; i < iban.length; i++) {
        const char = iban[i];

        // Check if the character is a letter
        if (/[A-Z]/i.test(char)) {
            // Convert to uppercase and replace with ASCII value - 55
            const asciiValue = char.toUpperCase().charCodeAt(0) - 55;
            transformedIban += asciiValue;
        } else {
            // Keep the digits as they are
            transformedIban += char;
        }
    }

    while(parseInt(transformedIban) >= 97) {
        let remainder = parseInt(transformedIban.substring(0, 9)) % 97

        transformedIban = remainder + transformedIban.substring(9) 
    }

    if(transformedIban!=1) {
        return false
    }

    return iban
}

async function getUserIdByIdNum(idNum) {
    let userId = await db.execute(`SELECT user_id
        FROM user_settings
        WHERE
            \`key\` = 'iinBin' AND value = '?';
        `, 
        [idNum])

        return userId
}

async function getCompanyRole(idNum, companyIdNum) {
    let userId = await db.query(`SELECT DISTINCT us1.user_id
    FROM user_settings us1
    INNER JOIN user_settings us2 ON us1.user_id = us2.user_id
    WHERE
        us1.\`key\` = 'iinBin' AND us1.value = '${idNum}'
        AND us2.\`key\` = 'bin' AND us2.value = '${companyIdNum}';`)

    if(userId.length == 0) return false

    let q = await db.selectOne('user_settings', {
        filter: {
            user_id: userId[0].user_id,
            key: 'companyRole'
        }
    })

    return q ? q.value : false
}

/**
 * 
 * @param {string} iin ИИН пользователя
 * @param {string} name Наименование ИП
 * @returns {Promise<Object>} { result: 'SUCCESS' | 'ERROR', message: message, isIP: ИП или нет, data: Инфо об ИП }
 */
async function getKGDIpInfo(iin, name = '', timeout = KGDAbortTimeout) {
    let data = {}
    let isIP = false

    let date = new Date()
    today = Math.floor(date.getTime() / 1000)

    if(!iin) return { result: 'ERROR', message: 'ИИН не предоставлен', isIP, data }
    if(!checkIdNum(iin)) return { result: 'ERROR', message: 'Неправильный ИИН', isIP, data }

    let token = process.env.KGD_TOKEN
    let url = `https://portal.kgd.gov.kz/services/isnaportalsync/public/taxpayer-data?taxpayerCode=${iin}&taxpayerType=IP${name ? `name=${name}` : ''}`

    try {
        let response = await fetch(url, { // fetch info from KGD API
            method: 'GET',
            headers: { 'Content-Type': 'application/json', 'X-Portal-Token': token },
            signal: AbortSignal.timeout(timeout)
        })

        if(!response.ok) { // if KGD response error
            const errorText = await response.text()
            console.error('Не удалось получить информацию об ИП', errorText)
            return { result: 'ERROR', message: 'Не удалось получить информацию об ИП', isIP, data }
        }
        response = await response.json()

        const { errorResponse = false, taxpayerPortalSearchResponses = false } = response

        if(taxpayerPortalSearchResponses && !taxpayerPortalSearchResponses.length) return {
            result: 'ERROR',
            message: 'Нет информации об ИП',
            isIP,
            data,
            confirmedNoRecord: true
        }

        if(errorResponse) { // if no info about IIN in KGD
            data.id_num = errorResponse.code ?? iin
            data.title = null
            data.begin_date = null
            data.end_date = null
            data.updated = today
            data.status = 0
            data.end_reason = null
            data.additional_info = null
            data.messageResult = errorResponse.messageResult
            data.errorMessage = errorResponse.errorMessage
            return { result: 'SUCCESS', message: errorResponse.errorMessage, isIP, data }
        }
        if(taxpayerPortalSearchResponses[0]) {
            let info = taxpayerPortalSearchResponses[0]

            let ipStatus = !!info.endDate ? 0 : 1

            let begin_date = Math.floor(new Date(info.beginDate).getTime() / 1000)
            let end_date = info.endDate ?? null

            if(end_date) end_date = Math.floor(new Date(end_date).getTime() / 1000)

            data.id_num = info.code ?? iin
            data.title = info.name
            data.begin_date = begin_date
            data.end_date = end_date
            data.updated = today
            data.status = ipStatus
            data.end_reason = info.endReason ? JSON.stringify(info.endReason) : null
            data.additional_info = info.additionalInfo ? JSON.stringify(info.additionalInfo) : null

            isIP = ipStatus == 1
        }

        return { result: 'SUCCESS', message: 'Информация успешно получена', isIP, data }
    } catch(error) {
        console.error('Не удалось получить информацию об ИП из KGD', error)
        return { result: 'ERROR', message: 'Не удалось получить информацию об ИП', isIP, data }
    }
}

async function getDatabaseIPInfo(iin) {
    let ip = await db.selectOne('individual_entrepreneurs', {
        filter: {
            id_num: iin
        }
    })

    return ip ?? false
}

async function refreshDatabaseIPInfo(iin, title = null, kgdTimeout = KGDAbortTimeout) {
    if(pendingKGDChecks.has(iin)) return pendingKGDChecks.get(iin)

    const refresh = (async () => {
        let kgdCheck = await getKGDIpInfo(iin, '', kgdTimeout)
        let today = Math.floor(new Date().getTime() / 1000)

        if(kgdCheck.result === 'SUCCESS') {
            let data = kgdCheck.data
            data.title = data.title ?? title ?? null

            try {
                await db.execute('INSERT INTO individual_entrepreneurs (id_num, title, begin_date, end_date, updated, status, end_reason, additional_info) VALUES (?, ?, ?, ?, ?, ?, ?, ?)', [
                    data.id_num, data.title, data.begin_date, data.end_date, data.updated, data.status, data.end_reason, data.additional_info
                ])
            } catch (error) {
                console.log('Error', error)
            }
        } else if(kgdCheck.confirmedNoRecord) {
            await db.execute('INSERT INTO individual_entrepreneurs (id_num, status, updated) VALUES (?, ?, ?)', [ iin, 0, today ])
        }

        return getDatabaseIPInfo(iin)
    })()

    pendingKGDChecks.set(iin, refresh)

    try {
        return await refresh
    } finally {
        pendingKGDChecks.delete(iin)
    }
}

// checkIP(990713350681)

async function checkIP(iin, options = {}) {
    if(!checkIdNum(iin)) return false
    if(extractFromIdNum(iin, 'type') === 'entity') return false
    iin = iin.toString()

    if(typeof options === 'number') options = { kgdTimeout: options }

    let { kgdTimeout = KGDAbortTimeout, waitForKGD = true } = options

    let title = null
    let [rec] = await db.execute(`SELECT * FROM recipients WHERE id_no = ? AND company_id_num = '' LIMIT 1`, [ iin ])

    if(rec) title = 'ИП ' + [rec.lastName, rec.firstName, rec.patronymic].filter(Boolean).join(' ')

    let check = await getDatabaseIPInfo(iin) // check IP table
    if(!check) { // if no records in DB - check KGD
        if(!waitForKGD) {
            refreshDatabaseIPInfo(iin, title, kgdTimeout).catch(error => {
                console.error('Не удалось обновить информацию об ИП из KGD', error)
            })
            return false
        }

        check = await refreshDatabaseIPInfo(iin, title, kgdTimeout)
    }
    check = check?.status === 1 ? check : false

    return check
}

async function getAllUserIdsByBin(bin) {
    let q = await db.select('user_settings', {
        filter: {
            key: 'bin',
            value: bin
        }
    })

    if (!q || q.length === 0) return []

    return [...new Set(q.map(item => item.user_id))]
}

module.exports = {
    isName,
    isPatronymic,
    isEmail,
    isPhoneNumber,
    isClearPhoneNumber,
    checkIdNum,
    checkIP,
    extractFromIdNum,
    getDatabaseIPInfo,
    getFullPhoneNumber,
    getObjectFromPhoneNumber,
    getPhoneNumberFromObject,
    getClearPhoneNumber,
    getCompanyRole,
    getUserIdByIdNum,
    getUsername,
    getFullName,
    getKGDIpInfo,
    isCanSignAuthorize,
    checkCanSignFromCompany,
    getBics,
    checkIban,
    getAllUserIdsByBin
}
